import React, { useState } from 'react'
import { Link } from "react-scroll";
import { FiMenu } from "react-icons/fi";
import { MdClose, MdLightMode } from "react-icons/md";
import {  FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { navLinksdata } from '../../constants';
import { useTheme } from '../theme/ThemeContext';

const Navbar = () => {
  const [showMenu, setShowMenu]=useState(false)
  const {darkTheme, setDarkTheme} = useTheme();

  const toggleTheme = () => {
 
    if(darkTheme === true){
      setDarkTheme(false)
    }
    else{
        setDarkTheme(true)
    }
  }
  return (
    <div className={darkTheme?"w-full h-24 sticky top-0 z-50 bg-bodyColor mx-auto flex justify-between items-center font-titleFont border-b-[1px] border-b-gray-600"
            :"w-full h-24 sticky top-0 z-50 bg-lightBodyColor mx-auto flex justify-between items-center font-titleFont border-b-[1px] border-b-gray-600"}
            >
      <div>
      </div>
      <div>
        <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-10">
          <li
            className={darkTheme?"text-base font-bold text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
          :"text-black font-bold text-black-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
          }>
            <li onClick={toggleTheme}>
            {darkTheme?"Lightmode":"darkmode"}
            </li>
          </li>
          {navLinksdata.map(({ _id, title, link }) => (
            <li
            className={darkTheme?"text-base font-bold text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
            :"text-black font-bold text-black-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
            } key={_id}
            >
              <Link
                activeClass="active"
                to={link}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                {title}
              </Link>
            </li>
          ))}
        </ul>
        <span
          onClick={() => setShowMenu(!showMenu)}
          className={darkTheme?"text-xl mdl:hidden bg-white w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"
          :"text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer"}
        >
          <FiMenu />
        </span>
        {showMenu && (
          <div className="w-[80%] h-screen overflow-scroll absolute top-0 left-0 bg-green-900 p-4 scrollbar-hide">
            <div className="flex flex-col gap-8 py-2 relative">
              <div>
                <p className={darkTheme?"text-sm text-gray-400 mt-2":"text-sm text-black-400 mt-2"}>
                I am a web developer proficient in Python Django, HTML5, CSS3, JavaScript and
                ReactJS,able to create enhanced user experiences through strategic animation.
                </p>
              </div>
              <ul className="flex flex-col gap-4">
              <li
            className={darkTheme?"text-base font-bold text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
          :"text-black font-bold text-black-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
          }>
            <li onClick={toggleTheme}>
            {darkTheme?"Lightmode":"darkmode"}
            </li>
          </li>
                {navLinksdata.map((item) => (
                  <li
                  className={darkTheme?"text-base font-bold text-gray-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                  :"text-black font-bold text-black-400 tracking-wide cursor-pointer hover:text-designColor duration-300"
                  } key={item._id}
                  >
                    <Link
                      onClick={() => setShowMenu(false)}
                      activeClass="active"
                      to={item.link}
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="flex flex-col gap-4">
              <h2 className={darkTheme?"text-base uppercase font-titleFont mb-4":"text-black uppercase font-titleFont mb-4"}>
                  Find me in
                </h2>
                <div className="flex gap-4">
               
                <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
                    <FaTwitter />
                  </span>
                  <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
                    <FaLinkedinIn />
                  </span>
                </div>
              </div>
              <span
                onClick={() => setShowMenu(false)}
                className={darkTheme?"absolute top-4 right-4 text-gray-400 hover:text-designColor duration-300 text-2xl cursor-pointer"
                  :"absolute top-4 right-4 text-black-400 hover:text-designColor duration-300 text-2xl cursor-pointer"}>
                <MdClose />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Navbar